/* RomartaLux — cheap scroll-in reveal, vanilla JS, no dependencies.
   Adds .rtx-in to any .rtx-reveal element once it's ~15% visible, once. */
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.rtx-reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('rtx-in'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rtx-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  items.forEach(function (el) { io.observe(el); });
});
